import type { ActionIdentifier } from "@/lib/stores/editor-store/creative-project-state";

type Listener = (id: ActionIdentifier) => void;

const listeners = new Set<Listener>();

export function emitInspirationAction(id: ActionIdentifier) {
  listeners.forEach((listener) => listener(id));
}

export function subscribeInspirationAction(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
